export const resizeOnInput = (target) => {
  target.style.height = 'auto';

  target.style.height = (target.scrollHeight+ 3) + 'px';
};
